import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/src/app/[locale]/(public)/not-found.tsx");
